import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { FloatButton } from "antd";
import { Navbar, WalletConnectionManager } from "./Components";
import { Home, NoPage, Pools, Portfolio } from "./Pages";
import { Toaster } from "sonner";
import TgBot from "./Pages/TgBot";


function App() {
  return (
    <div className="App scroll-smooth bg-gradient-to-b from-[#300034] to-black">
      <WalletConnectionManager>
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/*" element={<NoPage />} />
            <Route path="/pools" element={<Pools />} />
            <Route path="//tg-bot" element={<TgBot />} />
            <Route path="/portfolio" element={<Portfolio />} />
          </Routes>
        </BrowserRouter>

        <FloatButton.BackTop />
        <Toaster
          richColors
          closeButton
          duration={4000}
        />
      </WalletConnectionManager>
    </div>
  );
}

export default App;
